import OnSalePropertiesError from './OnSalePropertiesError';
class OnSalePropertiesInvalidQueryParam extends OnSalePropertiesError {
    constructor(queryParam, value, options) {
        super(`Query param ${queryParam} with the value ${value} is invalid`, options);
    }
}
export default OnSalePropertiesInvalidQueryParam;
